<script>
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'

import { merchantComputed } from '@state/helpers'

export default {
  components: { TheHeader, TheFooter },
  computed: {
    ...merchantComputed,
  },
}
</script>

<template>
  <div :class="$style.wrapper">
    <TheHeader />
    <img src="@assets/images/background.svg" :class="$style['background-circle-left']" />
    <img src="@assets/images/background.svg" :class="$style['background-circle-right']" />
    <img src="@assets/images/cloud1.svg" alt :class="$style.cloud1" />
    <img src="@assets/images/cloud2.svg" alt :class="$style.cloud2" />
    <img src="@assets/images/cloud1.svg" alt :class="$style.cloud3" />
    <img src="@assets/images/cloud2.svg" alt :class="$style.cloud4" />
    <slot />
    <TheFooter v-if="$route.name !== 'login' && $route.name !== 'line login'" />
  </div>
</template>

<style lang="scss" module>
%noDraggable {
  pointer-events: none;
  user-select: none;
}
.wrapper {
  position: relative;
  .cloud {
    &1 {
      position: absolute;
      top: 14vh;
      left: 4vw;
      width: 5vw;

      @extend %noDraggable;

      @include mobile {
        display: none;
      }
    }
    &2 {
      position: absolute;
      top: 13vh;
      right: 17vw;
      z-index: 0;
      width: 8vw;

      @extend %noDraggable;

      @include mobile {
        display: none;
      }
    }
    &3 {
      position: absolute;
      bottom: 6vh;
      left: 8vw;
      width: 6vw;

      @extend %noDraggable;

      @include mobile {
        width: 14vw;
      }
    }
    &4 {
      position: absolute;
      right: 9vw;
      bottom: 6vh;
      width: 8vw;

      @extend %noDraggable;

      @include mobile {
        width: 16vw;
      }
    }
  }

  .background-circle {
    &-left {
      position: fixed;
      top: 50%;
      left: 5vw;
      z-index: 0;
      margin-top: -230px;

      @extend %noDraggable;

      @include touch {
        display: none;
      }

    }
    &-right {
      position: fixed;
      top: 50%;
      right: 5vw;
      z-index: 0;
      margin-top: -230px;

      @extend %noDraggable;

      @include touch {
        display: none;
      }
    }
  }
}
</style>

